<template>
  <div class="info-card">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'InfoCard'
}
</script>

<style lang="scss" scoped>

.info-card{
  border: 2px solid #378e07;
  padding: 14px;
  height: 100%;
  max-width: 420px;
}

</style>
